import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProdManufacturingProcessTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import manufacturingIcon from "../../../../../assets/new-product-detail-cats/sub-icons/manufacturing-process-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdMaterialProcessContents = ({ productId, systemBoundaryProps }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });

  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="prod-manufacturing-contents">
      <SubHeaderBox
        subTitle={t("MANUFACTURING_PROCESS")}
        subDescription={t("MANUFACTURING_PROCESS_DESC")}
        isNormal={true}
        number={"33.1"}
        systemBoundaryProps={systemBoundaryProps}
        showSystemBoundary={true}
        icon={manufacturingIcon}
      />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-materialprocess-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdManufacturingProcessTable productId={productId} />{" "}
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdMaterialProcessContents;
